import { Flex } from 'antd'
import { createStyles } from 'antd-style'

import { FormGrid } from '@eastcoal/formily/components/FormGrid'
import { SchemaSearch } from '@eastcoal/formily/components/SchemaSearch'
import { toJS } from '@eastcoal/formily/exports/reactive'

import { pick } from '../../../utils/object'
import { ThrottleButton } from '../../Button/ThrottleButton'
import { useRemoteTableStore } from '../Store/hooks/useStore'

import { RemoteTableSearchFormProps } from './interface'

const useStyles = createStyles(({ prefixCls, token }) => ({
  searchForm: {
    paddingBlockEnd: token.padding,
    [`& + .crud-table-toolbar`]: {
      borderBlockStart: `1px solid ${token.colorBorderSecondary}`,
      paddingBlockStart: token.padding
    }
  }
}))

export const RemoteTableSearchForm = ({
  actions,
  onSearch,
  ...restProps
}: RemoteTableSearchFormProps) => {
  const { searchForm, request } = useRemoteTableStore(state =>
    pick(state, ['searchForm', 'request', 'pagination', 'requestParams'])
  )

  const handleSearch = () => {
    const normalValues = toJS(searchForm.values)
    const params = onSearch?.(normalValues) ?? normalValues
    request(params)
  }

  const handleReset = () => {
    searchForm.reset('*').then(handleSearch)
  }

  const { styles } = useStyles()

  return (
    <SchemaSearch
      {...restProps}
      className={styles.searchForm}
      form={searchForm}
    >
      <FormGrid.Column>
        <Flex gap={8} vertical={false}>
          <ThrottleButton onClick={handleReset}>重置</ThrottleButton>
          <ThrottleButton
            htmlType='submit'
            type='primary'
            onClick={handleSearch}
          >
            查询
          </ThrottleButton>
          {actions}
        </Flex>
      </FormGrid.Column>
    </SchemaSearch>
  )
}
